import { render, staticRenderFns } from "./DigitalCertificateQr.vue?vue&type=template&id=3b59a3be&scoped=true&"
import script from "./DigitalCertificateQr.vue?vue&type=script&lang=js&"
export * from "./DigitalCertificateQr.vue?vue&type=script&lang=js&"
import style0 from "./DigitalCertificateQr.vue?vue&type=style&index=0&id=3b59a3be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b59a3be",
  null
  
)

export default component.exports